<<template>
  <div>

    <privs-list ref="privInfo" :data="privData" :editable="true">
      <el-button type="primary" size="mini" @click="grant">
        授权
      </el-button>
      <el-button type="primary" size="mini" @click="submitForm">
        更新
      </el-button>
    </privs-list>

    <div v-if="lists.length">
      <div class="priv-title">
        已授权限
      </div>
      <div class="priv-tags">
        <el-tag v-for="item in lists" class="tag-tips" :effect="getPlain(item)" type='info' @click="toPrivs(item)">
          <span>
            {{ item.name }}
          </span>
        </el-tag>
      </div>

    </div>

    <el-dialog :close-on-click-modal="false" :title="$t('message.title.authorize')" :visible.sync="grantDialogVisible"
      width="50%"> <span>
        <template>
          <el-transfer :render-content="renderFunc" filterable :titles=tableName :button-texts="['', '']"
            v-model="assignedPrivs" :data="allPrivs"></el-transfer>
        </template>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="grantDialogVisible = false">{{ $t('message.button.cancel') }}</el-button>
        <el-button type="primary" icon="el-icon-setting" @click="authority" :loading="btnLoading"
          :disabled="btnDisabled">{{ $t('message.button.authorize') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

  <script>
  import axios from 'axios';
  // import PrivsForm from './privsForm.vue';
  import PrivsList from '../configComp/pageInfo.vue';
  export default {
    components: { PrivsList },
    props: ['privData'],
    data() {
      return {
        grantDialogVisible: false,
        btnLoading: false,
        btnDisabled: false,
        grantDialogVisible: false,
        loading: true,
        currentRoleId: "",
        roleData: [], //角色表格数据
        addForm: {}, //添加数据
        editForm: {}, //编辑数据
        addDialogVisible: false, //添加弹框的显示
        editDialogVisible: false, //编辑弹框
        data: [],
        allPrivs: [],
        assignedPrivs: [],
        tableName: [
          this.$t("message.transform.choices"),
          this.$t("message.transform.selected"),
        ],
        lists: []
      }
    },
    methods: {

      renderFunc(h, option) {//左侧列表添加鼠标划上显示
        return <span title={option.label}>{option.label}</span>;
      },
      async submitForm(e) {
        const saveData = this.$refs.privInfo.getEditData();
        const { id } = this.$route.query
        const obj = { id };
        saveData.map(i => {
          const { attrs, val } = i;
          obj[attrs] = val;
        })
        // return
        const { data } = await axios.post('/pmdm/admin/role/update?id=' + id, obj)
        if (data.code == 200) {
          this.$message.success(data.message);
          this.$emit('setRefresh');

        } else {
          this.$message.error(data.message);
        }
      },
      async grant() {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        const { data } = await axios.get("/pmdm/admin/priv/getAll");
        if (data.code == 200) {
          this.allPrivs = data.object.privs.map(j => ({
            key: j.id,
            label: j.name
          }));
          this.assignedPrivs = this.lists.map(i => i.id);
        }
        loading.close();
        this.grantDialogVisible = true;
      },
      async authority() {
        // this.btnDisabled = true;
        // this.btnLoading = true;
        const { data } = await axios.post(
          "/pmdm/admin/role/assignPrivs", {
          id: this.$route.query.id + '',
          assignedPrivs: this.assignedPrivs
        }
        );

        //console.log(res);
        if (data.code == 200) {
          this.getPrivById();
          this.$message.success(data.message);
        } else {
          this.$message.error(data.message);
        };

        this.btnDisabled = false;
        this.btnLoading = false;
        this.grantDialogVisible = false;
      },
      getPrivById() {
        const { id } = this.$route.query;
        if (!id) {
          return
        }
        axios.get(`/pmdm/admin/role/getPrivs?id=` + id).then(res => {
          console.log(res);
          const { privs } = res.data.object;
          this.lists = privs;
        })
      },
      toPrivs(item) {
        const name = "权限", title = "权限";
        const query = { item, name, title }, path = '/privs';

        if (!this.isExistingTab(name)) {
          this.$store.commit("setShowingTabsInHome", query);
        }

        this.$store.commit("setActivedTabInHome", name);
        this.$router.push({ path, query });
      },
      getPlain() {
        return 'plain'
      }
    },
    created() {
      this.getPrivById();
      console.log(this.privData);

    },
  }


</script>

  <style scoped>
  .priv-title {
    padding: 15px;
    border-bottom: 1px solid #d3d4d6;
    margin-top: 10px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .priv-tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .tag-tips {
    cursor: pointer;
  }

  .tag-tips span:hover {
    color: #409EFF;
  }
</style>